import React from 'react';
import { Check } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';

export const Programs = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const programs = [
    {
      id: 1,
      name: "Berçário",
      ageRange: "4 meses a 1 ano",
      description: "Ambiente acolhedor e seguro, com profissionais especializados no cuidado e desenvolvimento dos bebês. Estimulação sensorial e motora adequada para cada fase.",
      features: ["Cuidado especializado", "Estimulação sensorial", "Ambiente seguro", "Rotina personalizada"],
      image: "https://images.unsplash.com/photo-1588072432836-e10032774350"
    },
    {
      id: 2,
      name: "Maternal",
      ageRange: "1 a 3 anos",
      description: "Fase de descobertas e exploração. Atividades lúdicas que estimulam o desenvolvimento da linguagem, coordenação motora e socialização.",
      features: ["Atividades lúdicas", "Desenvolvimento motor", "Socialização", "Expressão criativa"],
      image: "https://images.unsplash.com/photo-1560130958-0ea787c275de"
    },
    {
      id: 3,
      name: "Educação Infantil",
      ageRange: "3 a 5 anos",
      description: "Proposta pedagógica que prepara as crianças para os desafios escolares futuros, desenvolvendo autonomia, criatividade e pensamento crítico.",
      features: ["Alfabetização lúdica", "Pensamento crítico", "Autonomia", "Preparação escolar"],
      image: "https://images.unsplash.com/flagged/photo-1551887373-6edba6dacbb1"
    }
  ];

  return (
    <section id="programs" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block mb-4">
            <span className="text-amber-600 font-semibold text-sm uppercase tracking-wider bg-amber-100 px-4 py-2 rounded-full">
              Nossos Programas
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Educação para Cada Fase
          </h2>
          <p className="text-lg text-gray-600">
            Programas especialmente desenvolvidos para atender as necessidades de cada faixa etária
          </p>
        </div>

        {/* Programs Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {programs.map((program) => (
            <Card 
              key={program.id}
              className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-amber-200 overflow-hidden"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={program.image}
                  alt={program.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                
                {/* Badge on Image */}
                <div className="absolute top-4 right-4">
                  <Badge className="bg-amber-500 text-white px-3 py-1 text-xs font-semibold shadow-lg">
                    {program.ageRange}
                  </Badge>
                </div>

                {/* Decorative Number */}
                <div className="absolute bottom-4 left-4 text-white/30 font-bold text-6xl leading-none">
                  0{program.id}
                </div>
              </div>

              <CardHeader>
                <CardTitle className="text-2xl text-gray-800 group-hover:text-amber-600 transition-colors">
                  {program.name}
                </CardTitle>
              </CardHeader>

              <CardContent>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {program.description}
                </p>

                {/* Features List */}
                <div className="space-y-3 mb-6">
                  <div className="flex items-start gap-2">
                    <div className="bg-gradient-to-br from-green-400 to-emerald-500 p-1 rounded-full flex-shrink-0 mt-0.5">
                      <Check className="text-white" size={14} />
                    </div>
                    <span className="text-gray-700 text-sm">{program.features[0]}</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="bg-gradient-to-br from-green-400 to-emerald-500 p-1 rounded-full flex-shrink-0 mt-0.5">
                      <Check className="text-white" size={14} />
                    </div>
                    <span className="text-gray-700 text-sm">{program.features[1]}</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="bg-gradient-to-br from-green-400 to-emerald-500 p-1 rounded-full flex-shrink-0 mt-0.5">
                      <Check className="text-white" size={14} />
                    </div>
                    <span className="text-gray-700 text-sm">{program.features[2]}</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <div className="bg-gradient-to-br from-green-400 to-emerald-500 p-1 rounded-full flex-shrink-0 mt-0.5">
                      <Check className="text-white" size={14} />
                    </div>
                    <span className="text-gray-700 text-sm">{program.features[3]}</span>
                  </div>
                </div>

                <Button 
                  onClick={scrollToContact}
                  className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white shadow-md hover:shadow-lg transition-all"
                >
                  Saiba Mais
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
